<template>
  <div id="wrapper" ref="wrapper">
    <video ref="remoteVideo" autoplay></video>
  </div>
</template>

<script>
  import webrtc from '../webrtc/webrtc-manager'
  import {RoomModel} from '../webrtc/greenroom-room-model'
  import Logger from '../webrtc/logger'
  import {result} from 'lodash'
  const logger = Logger.create('CEF:MediaViewer', ['CEF'])

  const getQueryParams = () => {
    const pl = /\+/g // Regex for replacing addition symbol with a space
    const search = /([^&=]+)=?([^&]*)/g
    const decode = s => decodeURIComponent(s.replace(pl, " "))
    const query = window.location.href.split('?')[1]
    const urlParams = {}
    let match
    while (match = search.exec(query)) {
      urlParams[decode(match[1])] = decode(match[2])
    }
    logger.info('Got query params', urlParams)
    return urlParams
  }

  const setCrop = (el, {cropLeft, cropTop, cropRight, cropBottom}) => {
    const left = -parseInt(cropLeft || 0)
    const top = -parseInt(cropTop || 0)
    const width = window.innerWidth - left + parseInt(cropRight || 0)
    const height = window.innerHeight - top + parseInt(cropBottom || 0)

    Object.assign(el.style, {
      left: `${left}px`,
      top: `${top}px`,
      height: `${height}px`,
      width: `${width}px`
    })
  }

  export default {
    name: 'Media',
    props: {
      roomId: {
        type: String,
        required: true
      },
      stream: {
        type: MediaStream
      }
    },
    async mounted () {
      const port = 3443

      let hostname = window.location.hostname
      try {
        let roomReq = await fetch(`https://${hostname}/api/webrtc/room/${this.roomId}`)
        let roomInfo = await roomReq.json()
        if (roomInfo.host) {
          hostname = roomInfo.host
        }
      } catch (e) {
      }
      logger.info(`Selected shard`, {hostname})

      const videoEl = this.$refs.remoteVideo
      const wrapperEl = this.$refs.wrapper
      const queryParams = getQueryParams()
      const {deviceId, peerId, type, volume} = queryParams
      const room = window.room = webrtc.ensureRoom(this.roomId, {id: this.roomId, displayName: 'Engine', serverHostname: hostname, serverPort: 3443})
      room.listenToOnlyPeerId = peerId
      if (deviceId) room.listenToOnlyDeviceId = deviceId

      webrtc.joinRoom(room.id)
      setCrop(wrapperEl, queryParams)

      window.addEventListener('message', () => {
        const {volume} = event.data
        if (typeof volume === 'number') {
          videoEl.volume = volume
        }
      }, false)

      videoEl.volume = volume || 1

      videoEl.onplaying = () => {
        logger.info(`Playing video...`, {mediaStream: result(this, 'peer.feed.stream')})
      }

      const getMatchingMedia = () => {
        logger.info('Getting matching media')
        if (deviceId) {
          return room.getMatchingMedia({deviceId, peerId, type})
        } else {
          return room.media.find(x => {
            return x.peerId === peerId && x.type === type && x.track
          })
        }
      }

      let media = window.media
      await room.addMedia({deviceId, peerId, type})

      const setStream = () => {
        const prev = media
        media = getMatchingMedia()
        logger.info('media/prev', {media, prev})
        if (prev) {
          if (prev === media) return logger.info('Media is not changed. Aborting.')
          logger.info('Had prev, stopped listening')
          prev.stopListening(prev)
        }
        if (media) {
          media.listenToAndRun(media, 'change:track', () => {
            logger.info('Track changed: setting source', media.track)
            videoEl.style.visibilty = 'hidden'
            if (!media.track) return
            const stream = new MediaStream([media.track])
            logger.info('Setting srcObject', stream)
            videoEl.srcObject = stream
            videoEl.style.visibilty = 'visible'
          })
        }
      }
      room.on('consumers:updated', () => {
        setStream()
      })
      setStream()
    }
  }

</script>
<style>
  #app {
    position: relative;
  }
  #wrapper {
    position: absolute;
    margin: 0 !important;
    overflow: hidden;
  }
  video {
    position: relative;
    height: 100%;
    width: 100%;
    object-fit: fill;
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// Media.vue?6fc0e38a